import { InjectionToken } from '@angular/core';

export interface RelayHostProgress {
  percent: number;
  step: number;
  total: number;
  cardLabel?: string;
}

/** Contract for an application that embeds the Relay form (e.g. the customer Portal). */
export interface RelayHost {
  /**
   * True when the host applies branding itself. Relay then renders no logo and injects no
   * stylesheet or font, and inherits the host's theme instead.
   */
  brandingOwnedByHost?: boolean;
  /** Fired once the form parameters have loaded and Relay has content to show. */
  onReady(): void;
  onProgress(progress: RelayHostProgress): void;
  onComplete(): void;
  /**
   * Whether the host may open Relay's help flow right now. Feature-flagged per tenant, and
   * withdrawn on the summary card, while help is open, and while a request is in flight.
   * A host that renders its own Help action implements this; standalone Relay keeps its own.
   */
  onHelpAvailable?(available: boolean): void;
}

const NOOP_RELAY_HOST: RelayHost = {
  onReady: () => undefined,
  onProgress: () => undefined,
  onComplete: () => undefined
};

/** Standalone Relay gets the no-op default; an embedding host provides its own. */
export const RELAY_HOST = new InjectionToken<RelayHost>('RELAY_HOST', {
  factory: (): RelayHost => NOOP_RELAY_HOST
});
